import { useGetAccountsQuery } from '../../../../redux/api/fymAPI';
import { useUserToken } from '../../../../redux/slices/appInfo/hooks';

/** The name of one artist of the workspace (the Pitch home hero, design outreach-v2 i1), or null while it loads. */
export function useArtistName(accountId: number): string | null {
  const userToken = useUserToken();
  const { name } = useGetAccountsQuery(undefined, {
    skip: !userToken,
    selectFromResult: ({ data }) => ({
      name: data?.accounts.find((account) => account.id === accountId)?.name ?? null,
    }),
  });
  return name;
}
